/**
 * Module: Cookie helpers for session control.
 */
;(() => {
  window.PopuppulseCookies = {
    set(name, value, hours) {
      const date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    },
    get(name) {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`))
        ?.split("=")[1];
    },
  };
})();

